import { RequestPayload, ResponseData, SuccessResponseDTO } from '../dtos/generic'
import { ReportTemplateDTO } from '../dtos/report'
import { defineRoute } from './new-helpers'

const basePath = '/organizations/:organizationId/report-templates'

export const ReportTemplatesRoutes = {
  createOne: defineRoute<
    'POST',
    ResponseData<ReportTemplateDTO>,
    RequestPayload<Pick<ReportTemplateDTO, 'name' | 'description' | 'instructions' | 'type'>>
  >({
    path: `${basePath}/create`,
  }),

  updateOne: defineRoute<
    'PATCH',
    ResponseData<ReportTemplateDTO>,
    RequestPayload<Partial<Pick<ReportTemplateDTO, 'name' | 'description' | 'instructions'>>>
  >({
    path: `${basePath}/:reportTemplateId`,
  }),

  deleteOne: defineRoute<'DELETE', ResponseData<SuccessResponseDTO>>({
    path: `${basePath}/:reportTemplateId`,
  }),

  getAll: defineRoute<'GET', ResponseData<ReportTemplateDTO[]>>({
    path: basePath,
  }),
}
